export var returnWrapper = function returnWrapper(awaitable) {
    return {
        promise: awaitable || Promise.resolve()
    };
}; //# sourceMappingURL=return-wrapper.js.map
